import { render, staticRenderFns } from "./ImageHoverCaption.vue?vue&type=template&id=7b85fea8&lang=pug&"
import script from "./ImageHoverCaption.vue?vue&type=script&lang=js&"
export * from "./ImageHoverCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports